<form #configForm="ngForm" (ngSubmit)="validate()" novalidate>
    <!-- Section pondérations -->
    <div class="boost-grid">
        <ng-container *ngFor="let field of boostFields">
            <div class="boost-item">
                <label [for]="field.key">
                    {{ field.label }}
                    <span matTooltip="{{ field.description }}" matTooltipPosition="right" class="tooltip-icon">
                        <i class="fa fa-info-circle"></i>
                    </span>
                </label>
                <input type="number" class="form-input" [class.invalid]="configForm.submitted && !config[field.key]"
                    [name]="field.key" [(ngModel)]="config[field.key]" required step="any"
                    [attr.placeholder]="field.label" />
            </div>
        </ng-container>
    </div>

    <br />
    <br />
    <br />

    <!-- Section Marques propres -->
    <div class="config-section">
        <h3>Marques propres</h3>
        <div *ngFor="let brand of config.ownBrands; let i = index" class="brand-entry">
            <input type="text" class="form-control" name="ownBrandName{{ i }}" [(ngModel)]="brand.brandName"
                placeholder="Nom de la marque" required [class.invalid]="configForm.submitted && !brand.brandName" />
            <input type="number" class="form-input" name="ownBrandWeight{{ i }}" [(ngModel)]="brand.weight" step="any"
                required placeholder="Poids" [class.invalid]="configForm.submitted && !brand.weight" />
            <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeOwnBrand(i)">
                <i class="fa fa-trash"></i> Supprimer
            </button>
        </div>
        <button class="btn btn-sm btn-outline-primary" type="button" (click)="addOwnBrand()">
            <i class="fa fa-plus"></i> Ajouter une marque propre
        </button>
    </div>

    <!-- Section Marques exclusives -->
    <div class="config-section">
        <h3>Marques exclusives</h3>
        <div *ngFor="let brand of config.exclusiveBrands; let i = index" class="brand-entry">
            <input type="text" class="form-control" name="exclusiveBrandName{{ i }}" [(ngModel)]="brand.brandName"
                placeholder="Nom de la marque" required [class.invalid]="configForm.submitted && !brand.brandName" />
            <input type="number" class="form-input" name="exclusiveBrandWeight{{ i }}" [(ngModel)]="brand.weight"
                step="any" required placeholder="Poids" [class.invalid]="configForm.submitted && !brand.weight" />
            <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeExclusiveBrand(i)">
                <i class="fa fa-trash"></i> Supprimer
            </button>
        </div>
        <button class="btn btn-sm btn-outline-primary" type="button" (click)="addExclusiveBrand()">
            <i class="fa fa-plus"></i> Ajouter une marque exclusive
        </button>
    </div>

    <!-- Boutons -->
    <div class="modal-footer">
        <button class="btn" type="button" (click)="close()">
            <i class="fa fa-times"></i> Annuler
        </button>
        <button class="btn btn-primary" type="submit" [disabled]="configForm.invalid">
            <i class="fa fa-check"></i> Valider
        </button>
    </div>
</form>